import { render, staticRenderFns } from "./logisticsDetail.vue?vue&type=template&id=49ffd64e&scoped=true"
import script from "./logisticsDetail.vue?vue&type=script&lang=js"
export * from "./logisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./logisticsDetail.vue?vue&type=style&index=0&id=49ffd64e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffd64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ffd64e')) {
      api.createRecord('49ffd64e', component.options)
    } else {
      api.reload('49ffd64e', component.options)
    }
    module.hot.accept("./logisticsDetail.vue?vue&type=template&id=49ffd64e&scoped=true", function () {
      api.rerender('49ffd64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/warehouse/logisticsDetail/logisticsDetail.vue"
export default component.exports